import { useLayoutEffect, useRef, useState, type ReactNode } from "react";
import { progress, type DemoScene, type DemoTarget } from "./demoScenario";

export function FocusTrace({ target, scene, time, still, className = "", round = false, children }: {
  target?: DemoTarget;
  scene: DemoScene;
  time: number;
  still: boolean;
  className?: string;
  round?: boolean;
  children: ReactNode;
}) {
  const targetRef = useRef<HTMLDivElement>(null);
  const [shape, setShape] = useState({ width: 0, height: 0, radius: 0 });

  useLayoutEffect(() => {
    const element = targetRef.current;
    if (!element) return;
    const measure = () => {
      const style = getComputedStyle(element);
      const width = element.offsetWidth;
      const height = element.offsetHeight;
      const radius = round ? Math.min(width, height) / 2 : parseFloat(style.borderTopLeftRadius) || 0;
      setShape({ width, height, radius: Math.min(radius, width / 2, height / 2) });
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [className, round]);

  const active = !!target && scene.target === target && !still;
  const draw = active ? progress(time, scene.end - 1800, 850) : 0;
  const press = active ? Math.sin(progress(time, scene.end - 300, 240) * Math.PI) : 0;
  return (
    <div ref={targetRef} className={`nd-target ${className}`} data-demo-target={target} style={{ transform: `scale(${1 - press * 0.045})` }}>
      {children}
      <svg className="nd-trace" aria-hidden="true" viewBox={`0 0 ${shape.width || 1} ${shape.height || 1}`}
        style={{ opacity: shape.width > 0 && draw > 0 ? 1 : 0 }}>
        <rect x="0.75" y="0.75" width={Math.max(0, shape.width - 1.5)} height={Math.max(0, shape.height - 1.5)}
          rx={Math.max(0, shape.radius - 0.75)} pathLength="1" fill="none" stroke="currentColor"
          strokeWidth="1.5" strokeDasharray={draw >= 1 ? "none" : "1"} strokeDashoffset={1 - draw} />
      </svg>
      <span className="nd-tap" style={{ opacity: press * 0.22 }} />
    </div>
  );
}
